<template>
    <p>
        Dashboard
    </p>
</template>

<script>
    export default {
        name: "Dashboard"
    }
</script>

<style scoped>

</style>
